import { Promotion } from '../../../../stores/promotion';

const renderDates = (_: unknown, record: Promotion) => {
    return (
        <div className={'dates_holder'} style={{ padding: '4px 0' }}>
            <div
                className="text_center inline_block"
                style={{ marginRight: '12px' }}
            >
                <div style={{ marginBottom: '2px' }}>
                    {record.startDate.format('ll')}
                </div>
                <div className={'lil_label'}>
                    {record.startDate.format('LT')}
                </div>
            </div>
            {record.endDate && (
                <div className="text_center inline_block">
                    <div style={{ marginBottom: '2px' }}>
                        {record.endDate.format('ll')}
                    </div>
                    <div className={'lil_label'}>
                        {record.endDate.format('LT')}
                    </div>
                </div>
            )}
        </div>
    );
};

export default renderDates;
